<template>
    <div class="ma-0 pa-0 d-flex align-center">
        <template v-if="showSelection"> {{ cur.name }}({{ cur.id }}) </template>
        <v-btn color="primary" dark @click="showList = true">
            <slot>
                <template v-if="selectedNames">{{ selectedNames }}</template>
                <template v-else>请选择促销</template>
            </slot>
        </v-btn>

        <v-dialog v-model="showList" id="list">
            <v-card>
                <v-card-title>
                    <v-text-field v-model="filter" solo placeholder="名称">
                        <template v-slot:append>
                            <v-btn @click="search" color="primary">查询</v-btn>
                            <v-icon @click="reload">$reload</v-icon>
                            <v-icon @click="add">$plus</v-icon>
                        </template>
                    </v-text-field>
                    <template v-for="(item, i) in selectedObjs" :key="i">
                        <v-btn @click="unSelectObj(item.id)">
                            {{ item.name }}x
                        </v-btn>
                    </template>
                </v-card-title>
                <v-card-text>
                    <template v-if="display == 'card'">
                        <v-card v-for="(obj, i) in objs" :color="obj.color" :key="i" class="mr-2 mb-2 d-inline-block">
                            <v-card-title>{{ obj.name }}
                                <v-icon @click="detail(obj)">mdi-information</v-icon>
                            </v-card-title>
                            <v-card-subtitle>{{ obj.typeL }} </v-card-subtitle>
                            <v-card-actions>
                                <v-btn color="primary" class="mr-2" small @click="addToSelected(obj)">选择</v-btn>
                            </v-card-actions>
                        </v-card>
                    </template>
                    <template v-else>
                        <v-data-table :headers="headers" :items="objs" :options.sync="options"
                            :server-items-length="parseInt(total)" :loading="loading" class="elevation-1">
                            <template v-slot:item.action="{ item }">
                                <v-btn small class="mr-2" @click="addToSelected(item)">选择</v-btn>
                            </template>
                        </v-data-table>
                    </template>
                </v-card-text>
                <v-card-actions v-if="multiple">
                    <v-btn @click="confirmSelectedObjs" color="primary">确定</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="editDlg">
            <v-card>
                <sale-form v-model="editForm" :errors="editErrors">
                    <template #actions="{ object }">
                        <v-btn @click="editDlg = false">取消</v-btn>
                        <v-btn @click="save(object)" color="primary">确定</v-btn>
                    </template>
                </sale-form>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import BaseSelector from '../common/BaseSelector.vue'
import SaleForm from './FormShop.vue'
import { format } from 'date-fns'
export default {
    components: { SaleForm },
    extends: BaseSelector,
    props: {
        current: { type: [Number, String], default: null },
        shopId: { type: [Number, String], default: null },
        multiple: { type: Boolean, default: false },
        display: { type: String, default: 'card' },
        showSelection: { type: Boolean, default: false },
        base: { type: String, default: 'order' }
    },
    data() {
        return {
            objs: [],
            pageno: 0,
            pagesize: 100,
            selectedObj: null,
            selectedObjId: null,
            selectedObjs: [],

            filter: '',

            cur: null, //当前分类
            curPath: [],
            curChildren: [],
            showList: false,

            total: 0,
            loading: false,
            options: {},
            headers: [
                { text: '#', value: 'id' },
                { text: '名称', align: 'left', sortable: true, value: 'name' },
                { text: '类型', value: 'type' },
                { text: '开始时间', value: 'starttime' },
                // { text: '结束时间', value: 'endtime' },
                { text: '状态', value: 'status' },
                { text: '', align: 'left', sortable: false, value: 'action' }
            ],
            detailDlg: false,
            detailObj: {},
            editDlg: false,
            editForm: {},
            editErrors: {}
        }
    },
    methods: {
        save(form) {
            this.$api.sale.update(form, (response) => {
                alert('保存成功')
                this.editDlg = false
            }, (e) => {
                this.editErrors = e.message
            })
        },
        add() {
            this.editForm.base = 'order'
            this.editForm.status = 'start'
            this.editForm.starttime = format(new Date(), 'yyyy-MM-dd HH:mm')
            this.editDlg = true
        },
        edit(o) {
            this.editForm = clone(o)
            this.editDlg = true
        },
        search() {
            let pageno = this.pageno + 1
            let params = {
                pageno: pageno,
                pagesize: this.pagesize
            }
            if (this.shopId) params.shopid = this.shopId
            params.base = this.base
            this.$api.sale.search(
                params,
                (response) => {
                    this.objs = response.objects
                    this.total = response.total
                },
                (error) => {
                    console.log(error)
                }
            )
        },
        detail(obj) {
            this.detailObj = obj
            this.detailDlg = true
        }
    }
}
</script>
